import { Chain } from "@swapkit/core";

import { ForgeModels } from "./ForgeModels";
import { ForgeThorname, ForgeTNS } from "./types";

export const parseThorname =
  (ctx: typeof ForgeModels.prototype) =>
  (thorname: ForgeThorname): ForgeTNS => {
    const thornameTypeProps =
      thorname?.owner && thorname?.expire
        ? ({
            type: "thorname",
            owner: thorname?.owner,
            expiresAt: ctx.getDateFromExpiryBlockHeight(thorname?.expire),
          } as const)
        : ({
            type: "unregistered_thorname",
            owner: null,
            expiresAt: undefined,
          } as const);

    const name = thorname?.tns?.toLowerCase();

    // @ts-expect-error TODO
    return {
      ...thorname?.entries?.find((entry) => entry?.chain === Chain.THORChain),
      name,
      nameWithExtension: `${name}.thor`,
      fee: "0",
      activeOffers: [],
      activity: [],
      createdAt: null,
      entries: thorname?.entries,
      id: Math.floor(Math.random() * 1000000),
      buyer: null,
      updatedAt: null,
      transferFeeDetails: null,
      transferThornameDetails: null,
      transferBuyDetails: null,
      transferTNSToNewOwnerDetails: null,
      transferForgeFeeDetails: null,
      transferProfitToPreviousOwnerDetails: null,
      price: null,
      status: null,
      escrowWalletId: null,
      soldAt: null,
      categories: [],
      ...thornameTypeProps,
    };
  };
